import { render, staticRenderFns } from "./UsersPrivilegePlacesMedia.vue?vue&type=template&id=739217bd&scoped=true&"
import script from "./UsersPrivilegePlacesMedia.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegePlacesMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739217bd",
  null
  
)

export default component.exports